const routes = [
  {
    path: 'bottleneck-machine-dashboard',
    name: 'bottleneckMachineDashboard',
    component: () => import(/* webpackChunkName: "bottleneck-machine-dashboard" */ './views/UserDashboard.vue'),
    meta: {
      permissionRequired: false,
    },
  },
];

export default routes;
